module.exports = __webpack_public_path__ + "assets/img/sy_vr_bg.cd882c2f.png";